import React, { useCallback } from "react";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { planAuditFieldName } from "../../validationSchema/planAuditSchema";
import { Text } from "react_reusable_components";
import { useIntl } from "react-intl";
import Style from "./DnsdSelectContainer.module.scss";

export default function DnsdSelectContainer({
  dnsdList,
  values,
  errors,
  touched,
  validateField,
  setValues,
}) {
  const intl = useIntl();

  const filterOptionFn = useCallback((input, option) => {
    const searchStr = input?.toLowerCase();
    return (
      option.name?.toLowerCase()?.includes(searchStr) ||
      option.globalId?.toLowerCase()?.includes(searchStr)
    );
  });

  function setDnsdAndDate(selectedDnsd, data) {
    const dnsdObjArr = data[planAuditFieldName.DNSD_OBJ_ARR];

    return selectedDnsd.map((dnsdId) => {
      const existingDnsd = dnsdObjArr?.find(
        ({ dnsd_id }) => dnsd_id === dnsdId
      );

      if (existingDnsd) {
        return existingDnsd;
      }

      return {
        dnsd_id: dnsdId,
        [planAuditFieldName.TENTATIVE_DATE]: "",
        [planAuditFieldName.TM_ID]: "",
      };
    });
  }
  return (
    <CustomSelect
      label={getLocalizedMessage(intl, "planAudit.dnsd.label")}
      required={true}
      showSearch={true}
      placeholder={getLocalizedMessage(intl, "planAudit.dnsd.placeholder")}
      type="multipleSelect"
      mode="multiple"
      filterOption={filterOptionFn}
      options={dnsdList?.map?.(({ name, id, isActive, globalId }) => {
        return {
          label: (
            <Text
              className={`${Style["select-item-style"]} ${
                !isActive && Style["low-opacity"]
              }`}
            >
              {name} ({globalId})
            </Text>
          ),
          value: id,
          name,
          globalId,
          disabled: !isActive,
        };
      })}
      name={planAuditFieldName.DNSD}
      value={values[planAuditFieldName.DNSD]}
      onChange={(e) => {
        setValues((prev) => ({
          ...prev,
          [planAuditFieldName.DNSD]: e,
          [planAuditFieldName.DNSD_OBJ_ARR]: setDnsdAndDate(e, values),
        }));
      }}
      onBlur={() => {
        validateField(planAuditFieldName.DNSD);
      }}
      error={
        touched[planAuditFieldName.DNSD] && errors[planAuditFieldName.DNSD]
      }
      disabled={
        values[planAuditFieldName.AUDIT_TYPE] === "Repair" &&
        !values[planAuditFieldName.PRODUCT_SUB_CATEGORY_ID]
      }
    />
  );
}
